<script>
	import { navigate } from "svelte-routing";
	import CustomTable from "../../../../components/CustomTable/CustomTable.svelte";

	export let reportData = [];

	let sortColumn = "";
	let sortDirection = 1;

	$: console.log("rejected");

	function navigateToDetails(vehicleId) {
		navigate(`/issues/case-management/rejected/${vehicleId}`);
	}

	function toggleSort(column) {
		if (numColumn === column) {
			sort.sortDir = sort.sortDir === 0 ? 1 : 0;
		} else {
			sort.sortDir = 0;
		}
		numColumn = column;
		sort.sortCol = column;
		handleSort(sort);
	}
</script>

<CustomTable
	columns={[
		{ label: "Vehicle No", key: "plateNo", type: "link" },
		{
			label: "Case Closed On",
			key: "rejectedAt",
			type: "date",
			sortCol: 0,
		},
		{ label: "Investigator", key: "investigator" },
		{
			label: "Reason",
			key: "rejectedReason",
			type: "status",
			options: "damages",
		},
		{
			key: "actions",
			label: "Actions",
			type: "actions",
			event: navigateToDetails,
			action: "view",
		},
	]}
	rows={reportData}
	emptyMessage="There are currently no cases to display."
/>
